import axios from "axios";
import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

export const MyContext = createContext();

const MyContextProvider = (props) => {
  const API_BASE_URL = process.env.REACT_APP_NODE;
  const navigate = useNavigate();
  const [showPayment, setShowPayment] = useState(false);
  const [verifyMlmUser, setVerifyMlmUser] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cartItems, setCartItems] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [search, setSearch] = useState([]);
  const [serchItem, setSearchItem] = useState("");
  const [exitUserId, setExistUserId] = useState(false);
  const [pending, setPending] = useState(true);
  const [KYC,setKYC]=useState();
  const [Bank,setBank]=useState();
  const MLMStatus = localStorage.getItem("MLMStatus") || null;
  const userId = localStorage.getItem("userId") || null;
  const token = localStorage.getItem("token") || null;
  const [showWithdrawAmountPopUp, setShowWithdrawAmountPopUp] = useState(false);

  const getSearchItem = (item) => {
    axios
      .get(`${API_BASE_URL}user/search?q=${item}`)
      .then((response) => {
        setSearch(response?.data?.data);
      })
      .catch((error) => {});
  };

  const [wallet, setWallet] = useState([]);

  const getWallet = (userId) => {
    axios
      .get(`${API_BASE_URL}user/walletTransactions/${userId}`)
      .then((res) => {
        setWallet(Array.isArray(res?.data?.data) ? res?.data?.data : []);
      })
      .catch((err) => {});
  };
  const checkMLMUser = () => {
    try {
      axios
        .get(`https://api.ourmicrolife.com/api/user/profile/${userId}`)
        .then((res) => {
          const Data = res?.data?.data;
          console.log(res);
          setKYC(Data.kyc_status)
          setBank(Data.filled_bankDetail)
          localStorage.setItem("MLMStatus", Data?.MLMStatus);
          setExistUserId(true);
          console.log("user ======================================  ", Data);
          localStorage.setItem("level", Data?.level);
          setVerifyMlmUser(Data?.MLMStatus);
          localStorage.setItem("profilePicture", Data?.profile_picture);
          localStorage.setItem(
            "userName",
            `${Data?.first_name} ${Data?.last_name}`
          );
        })
        .catch((err) => {
          console.log(err);
          setExistUserId(false);
          setVerifyMlmUser(0)
        });
    } catch (err) {}
  };

  const fetchCartItemsContext = async () => {
    setLoading(true);
    setError(null);

    if (!token || !userId) {
      setError("You need to log in to view the cart.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PUBLIC_API_BASE_URL}cart/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Use the token to authenticate the request
          },
        }
      );
      console.log(response.data);
      let products = response.data.cart.products;
      setCartItems(products.length);
      let sum = 0;
      for (let i = 0; i < products.length; i++) {
        sum += parseInt(products[i].pivot.price * products[i].pivot.quantity);
      }
      // console.log("total price ", totalPrice, sum);
      setTotalPrice(sum);
      // console.log("carts items", response.data.cart.products);
    } catch (error) {
      console.error("Error fetching cart items:", error);
      setError("Failed to load cart items.");
    } finally {
      setLoading(false);
    }
  };

  const [data, setData] = useState(null);
  const [bankdata, setBankdata] = useState(false);
  const [Disable, setDisable] = useState(false);

  const getBankDetails = async () => {
    const userId = localStorage.getItem("userId");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODE}/user/banks/${userId}`
      );
      console.log(response);
      setData(response.data.data);
      if (response.status === 200) {
        setDisable(true);
        setPending(false);
      }
      setBankdata(true);
    } catch (err) {
      setBankdata(false);
    }
  };

  const [KycData, setKycData] = useState(null);
  const [kycPending, setKycPending] = useState(true);

  const getKycData = async () => {
    await axios
      .get(`${process.env.REACT_APP_NODE}/user/KYCDetails/${userId}`)
      .then((response) => {
        if (response.data.dataGetUser.length > 0) {
          setKycPending(false);
        }

        setKycData(response?.data?.dataGetUser[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [upiDetail, setUpiDetails] = useState(null);
  const [upiDisable, setUpiDisable] = useState(false);
  const getUpiDetail = async () => {
    await axios
      .get(`${process.env.REACT_APP_NODE}user/upiDetails/${userId}`)
      .then((response) => {
        console.log(
          response.data.upiDetails,
          "+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++"
        );
        setUpiDetails(response.data.upiDetails[0]);
        if (response.data.upiDetails.length > 0) {
          setUpiDisable(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [nomineeData, setNomineeData] = useState(null);
  const getNomineeDetail = async () => {
    await axios
      .get(`${process.env.REACT_APP_NODE}user/nomineeDetails/${userId}`)
      .then((response) => {
        console.log(
          response?.data?.data,
          "+++++++++++++++++++++++++++++++++++++=================================================="
        );
        setNomineeData(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const value = {
    navigate,
    showPayment,
    setShowPayment,
    checkMLMUser,
    search,
    setSearch,
    getSearchItem,
    serchItem,
    setSearchItem,
    exitUserId,
    verifyMlmUser,
    setVerifyMlmUser,
    getWallet,
    wallet,
    cartItems,
    MLMStatus,
    fetchCartItemsContext,
    setPending,
    pending,
    data,
    setData,
    bankdata,
    setBankdata,
    Disable,
    setDisable,
    getBankDetails,
    KycData,
    setKycData,
    kycPending,
    setKycPending,
    getKycData,
    getUpiDetail,
    upiDisable,
    getNomineeDetail,
    nomineeData,
    upiDetail,
    showWithdrawAmountPopUp,
    setShowWithdrawAmountPopUp,
  };
  return (
    <MyContext.Provider value={value}>{props.children}</MyContext.Provider>
  );
};

export default MyContextProvider;
